import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DevicesStore, FeatureService, InstallationFeaturesStore } from '@store';
import {
  ConsolidatedFeature,
  EssInverterPowerProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsNumberValueProperty,
} from '@vi-iot/client/index';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-battery-overall',
  templateUrl: './battery-overall.component.html',
  styleUrls: ['./battery-overall.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatteryOverallComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  power$: Observable<Feature<EssInverterPowerProperties, unknown>>;
  powerConsolidated$: Observable<Feature<ConsolidatedFeature, unknown>>;
  stateOfCharge$: Observable<Feature<IsNumberValueProperty, unknown>>;
  stateOfChargeConsolidated$: Observable<Feature<ConsolidatedFeature, unknown>>;
  capacity$: Observable<Feature<ConsolidatedFeature, unknown>>;
  capacityConsolidated$: Observable<Feature<ConsolidatedFeature, unknown>>;

  constructor(
    public devicesStore: DevicesStore,
    private featureService: FeatureService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}
  ngOnInit(): void {
    this.power$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.powerConsolidated
    );
    this.powerConsolidated$ = this.featureService.getConsolidatedFeatures(
      FeatureNames.powerConsolidated
    );

    this.stateOfCharge$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.stateOfCharge
    );
    this.stateOfChargeConsolidated$ = this.featureService.getConsolidatedFeatures(
      FeatureNames.stateOfChargeConsolidated
    );

    this.capacity$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.stateOfCapacityNominal
    );
    this.capacityConsolidated$ = this.featureService.getConsolidatedFeatures(
      FeatureNames.stateOfCapacityNominalConsolidated
    );
  }
}
